import {
    getList,
    postItem,
    patchItem,
    getItem,
    deleteItem
} from "./utils/entity-network-requests"

const entityName = "system_notification"

export const getNotificationList = (token, parameters) =>
    getList(entityName, parameters, token)
export const getNotificationItem = (token, id) => getItem(entityName, id, token)
export const patchNotificationItem = (token, id, notification) => {
    let context = {}
    if ("link" in notification) {
        let {link, ...newNotification} = notification
        context = {...context, link}
        notification = newNotification
    }
    if ("entity_id" in notification) {
        let {entity_id, ...newNotification} = notification
        context = {...context, entity_id}
        notification = newNotification
    }
    if (Object.keys(context).length) {
        notification = {...notification, context}
    }
    return patchItem(entityName, id, notification, token)
}

export const postNotificationItem = (token, notification) => {
    let {link, entity_id, ...newNotification} = notification
    let context = {}
    if (link) {
        context = {...context, link}
    }
    if (entity_id) {
        context = {...context, entity_id}
    }
    if (Object.keys(context).length) {
        newNotification = {...newNotification, context}
    }
    return postItem(entityName, newNotification, token)
}

export const deleteNotificationItem = (token, id) => deleteItem(entityName, id, token)
